import { GLOBAL_SEARCH_COMPONENT, globalSearchComponentDef } from 'navigation-components/config';
import { useComponentProps, useComponentState, useInvokeFunction, useToggleComponent } from 'navigation-components/platform/hooks';
import { useCallback, useRef } from 'react';
import { GLOBAL_SEARCH_QUERY_PARAM, handleError } from '../constants';
// Handles the updating of URL query parameters using URLSearchParams.
const updateURLParams = (key, value) => {
  const urlQueryParams = new URLSearchParams(window.location.search);
  if (value === '' || value === undefined || Array.isArray(value) && !String(value)) {
    urlQueryParams.delete(key);
  } else {
    urlQueryParams.set(key, value.toString());
  }
  const paramString = urlQueryParams.toString() === '' ? window.location.pathname : `?${urlQueryParams.toString()}`;
  window.history.replaceState({}, '', paramString);
};
const useSearchComponent = (isMinified = false) => {
  const {
    invoke
  } = useInvokeFunction(globalSearchComponentDef);
  const dimensions = useRef({
    viewport: {
      height: window.innerHeight,
      width: window.innerWidth
    },
    wrapper: {
      height: 0,
      width: 0
    }
  });
  const setDimensions = useCallback(({
    viewport,
    wrapper
  }) => {
    dimensions.current = {
      viewport: viewport ? Object.assign({}, dimensions.current.viewport, viewport) : dimensions.current.viewport,
      wrapper: wrapper ? Object.assign({}, dimensions.current.wrapper, wrapper) : dimensions.current.wrapper
    };
    invoke('parentWindowResize', {
      height: dimensions.current.viewport.height,
      width: dimensions.current.viewport.width
    }).catch(handleError);
    invoke('searchWrapperResize', {
      height: dimensions.current.wrapper.height,
      width: dimensions.current.wrapper.width
    }).catch(handleError);
  }, [invoke]);
  const {
    isOpen
  } = useComponentState(GLOBAL_SEARCH_COMPONENT);
  const searchComponentProps = useComponentProps(globalSearchComponentDef);
  const {
    toggle: toggleSearchComponent
  } = useToggleComponent(GLOBAL_SEARCH_COMPONENT);
  const updateSearchComponentProps = useCallback(partialUpdate => {
    searchComponentProps(currentProps => Object.assign({}, currentProps, partialUpdate));
    setDimensions({});
  }, [searchComponentProps, setDimensions]);
  const loadAndShowSearch = useCallback(searchData => {
    if (searchData) {
      const {
        searchQuery: query = '',
        searchFilters = '',
        searchPreFiltered = ''
      } = searchData;
      const searchQuery = query.substring(0, 512);
      updateSearchComponentProps({
        searchQuery,
        searchFilters,
        searchPreFiltered
      });
      if (!isMinified) updateURLParams(GLOBAL_SEARCH_QUERY_PARAM, searchQuery);
    }
    if (!isOpen) {
      toggleSearchComponent(true);
    }
    setDimensions({});
  }, [isOpen, toggleSearchComponent, updateSearchComponentProps, isMinified, setDimensions]);
  return {
    loadAndShowSearch,
    updateSearchComponentProps,
    updateURLParams,
    setDimensions
  };
};
export default useSearchComponent;